require('./hireCardOpenDebitStep4.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @constants
const {
    SECOND_STEP,
    FOURTH_STEP,
    HYPHEN
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { OPEN_DEBIT_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    OPEN_DEBIT,
    messages: {OPEN_DEBIT_AND_GDPR}
} = require('constants/operationTypes');
const { OPEN_DEBIT_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
const {
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    R42_CARD_PRODUCT_ALIAS,
    R42_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');

class hireCardOpenDebitStep4 extends React.Component {
    componentDidMount() {
        const {
            originCountry,
            sendPrecontractualDocumentMail,
         } = this.props;

         let precontractualMailProductInfo = {
            productAlias: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
            productName: OPEN_DEBIT_CARD_PRODUCT_NAME
        };

        //If origin country is Portugal or Germany R42 documentation should be used
        if (originCountry === 'PT' || originCountry === 'DE') {
            precontractualMailProductInfo = {
                productAlias: R42_CARD_PRODUCT_MIN_ALIAS,
                productName: R42_CARD_PRODUCT_ALIAS,
            };
        }

        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            this.props.setTermsAndCondsText('hireCardOpenDebit-hireCardOpenDebit_confirmationStepAgreementText');
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardNameSelector,
            immHireCardOpenDebit,
            immShippingAddress,
            originCountry,
        } = this.props;
        const selectedAccount = immHireCardOpenDebit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        const addressValue = immShippingAddress.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddress, originCountry);

        return (
            <div className="hire-card-open-debit-step-four__summary row">
                <div className="col-xs-3 print-label">
                    <div className="hire-card-open-debit-step-four__summary-label">
                        <FormattedText value="hireCardOpenDebit-summarySelectedName" />
                    </div>
                    <div className="hire-card-open-debit-step-four__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="hire-card-open-debit-step-four__summary-label">
                        <FormattedText value="hireCardOpenDebit-summarySelectedAccount" />
                    </div>
                    <div className="hire-card-open-debit-step-four__summary-value">
                        <span>{immAccount.get('alias')}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
                <div className="col-xs-5 print-label">
                    <div className="hire-card-open-debit-step-four__summary-label">
                        <FormattedText value="hireCardOpenDebit-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-open-debit-step-four__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardOpenDebit, operativeName, immPdfData } = this.props;
        const immStep = immHireCardOpenDebit.getIn(['steps', FOURTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardOpenDebit-hireCardOpenDebit_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardOpenDebit-step3CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName('print-title', 'hire-card-open-debit-step-four__title')
        const hireCardSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-open-debit-step-four__subtitle')
        const operationParams = [{
            serviceCode: OPEN_DEBIT
        },{
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];
        const preContractDocumentInfo = getCardsPreContractPdfData()['open_debit'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-open-debit-step-four__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardOpenDebitAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={this.props.handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={OPEN_DEBIT_AND_GDPR}
                />
            )
        }

        return (
            <article className="hire-card-open-debit-step-four">
                <FormattedText
                    className={hireCardTitleClassName}
                    value="hireCardOpenDebit-step3Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className={hireCardSubTitleClassName}
                    value="hireCardOpenDebit-step3Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={OPEN_DEBIT_GDPR_PID} />
                <WebappRender>
                    <div className="hire-card-open-debit-step-four__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                        />
                    </div>
                </WebappRender>
                <div className="hire-card-open-debit-step-four__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="hireCardOpenDebit-addressHint" className="no-print-out"/>
                    </OKMessage>
                </div>
                {agreementCheckboxContent}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

hireCardOpenDebitStep4.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardOpenDebit: PropTypes.object.isRequired,
    immPdfData: PropTypes.object,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    originCountry: PropTypes.string.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = hireCardOpenDebitStep4;
